/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {AnalyticsIds} from '@ion/core/src/analytics/types';
import {AssetCategoryFilter} from '@ion/dls/src/filters/AssetCategoryFilter';
import {Filters} from '@ion/dls/src/types/types';
import {FilterParamsType} from '../types';

interface CategoriesFilterParamsType extends FilterParamsType {}

export const CategoriesFilter = ({
  isPhone,
  globalGroupId,
  toggleView,
  filterState,
  handleSubmit
}: CategoriesFilterParamsType) => (
  <AssetCategoryFilter isMobileView={isPhone}
    elementId={AnalyticsIds.assetHistoryCategoryFilter}
    name={Filters.assetCategories}
    accountId={globalGroupId}
    onCancel={toggleView}
    onMenuClose={toggleView}
    filterState={filterState[Filters.assetCategories]}
    onSubmit={handleSubmit} />
);
